{
  "breaches": {
    "count": "Ihre Kontodaten sind bei {count} Datenschutzverletzungen durchgesickert.",
    "discovered": "Dieser Verstoß wurde erstmals am {date} entdeckt.",
    "empty": {
      "text": "Wir haben keine Datenlecks für Ihr Konto gefunden.",
      "title": "Keine Datenlecks gefunden"
    },
    "high": "Hoch",
    "medium": "Mittel",
    "title": "Verstöße",
    "watchlist": {
      "button": "E-Mail hinzufügen",
      "text": "Überwachte E-Mails",
      "title": "Beobachtungsliste"
    }
  },
  "cards": {
    "breaches": {
      "text": "Auf dieser Seite können Sie die Anzahl der Datenschutzverletzungen überprüfen, von denen Ihr Konto betroffen war. Wir kategorisieren die Datenschutzverletzungen nach ihrem Schweregrad und der Art der Daten, die durchgesickert sind. Ändern Sie unbedingt Ihre Passwörter, wenn Ihre Daten durch eine Datenschutzverletzung offengelegt wurden.",
      "title": "Wurden Ihre Daten weitergegeben?"
    },
    "overview": {
      "text": "Hallo {name}! Wie Sie vielleicht wissen, werden Phishing-Angriffe immer komplexer und gefährlicher. Der Hub ist ein Ort, an dem Sie Ihre Fortschritte verfolgen und noch mehr über die Cyberangriffe erfahren können, die Ihr Unternehmen bedrohen. Vervollständigen Sie Sicherheitsleistungen und werden Sie in kürzester Zeit zum Sicherheitsexperten.",
      "title": "Willkommen bei The Hub!"
    },
    "quiz": {
      "text": "Begeben Sie sich auf unsere interaktive Quiz-Reise und fordern Sie Ihre Fähigkeiten heraus, zwischen echten und Phishing-E-Mails zu unterscheiden. Das Quiz wurde entwickelt, um Ihr Wissen und Ihr Verständnis für die Bedrohungen, die es gibt, zu testen.",
      "title": "Ein Quiz für Sie!"
    },
    "simulations": {
      "text": "Auf dieser Seite können Sie die Details der Simulationen einsehen, die Sie in den letzten 90 Tagen von Moxso erhalten haben. Wenn Sie verstehen, wie Phishing-E-Mails aufgebaut sind, können Sie sie erkennen und sich vor ihnen schützen.",
      "title": "Sind Sie Opfer eines Phishings geworden?"
    },
    "videos": {
      "text": "Auf dieser Seite können Sie sich Videos über die neuesten Cyber-Bedrohungen ansehen und lernen, wie Sie sich und Ihr Unternehmen vor diesen Bedrohungen schützen können. Unsere Schulungsvideos können Sie sich jederzeit ansehen.",
      "title": "Auf die Plätze, fertig, los!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Abschlusszertifikat",
    "certificate_unlocked": "Zertifikat freigeschaltet",
    "share_on_linkedin": "Auf LinkedIn teilen",
    "show_certificate": "Zertifikat anzeigen",
    "text": "Du hast ein Zertifikat aus einem kürzlich abgeschlossenen Kurs. Warum zeigst du es nicht?"
  },
  "courses": {
    "all": "Alle Kurse",
    "completed": {
      "badge": "Abgeschlossen",
      "button": "Vollständiger Kurs",
      "text": "Sie haben den Kurs abgeschlossen",
      "title": "Sehr gut gemacht!"
    },
    "content": {
      "breach": {
        "text": "Aktivieren Sie die Erkennung von Sicherheitsverletzungen für Ihr Konto",
        "title": "Erkennung von Verstößen einrichten"
      },
      "download": {
        "button": "Download"
      },
      "introduction": {
        "contents": "Inhalt",
        "start": "Kurs starten",
        "text": "Kurseinführung und Überblick",
        "title": "Einführung"
      },
      "quiz": {
        "choose_answer": "Wählen Sie unten die richtige Antwort aus:",
        "correct": "Richtig",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Richtige Antwort",
        "next_question": "Nächste Frage",
        "oh_no": "Schade!",
        "question_of": "Frage {current} von {total}",
        "result": {
          "button": "Quiz abschließen",
          "text": "Sie haben {correct} von {total} Fragen richtig beantwortet.",
          "title": "Gut gemacht!",
          "title_fail": "Fast geschafft!"
        },
        "text": "Stellen Sie Ihr Wissen mit einem Quiz auf die Probe",
        "title": "Quiz",
        "view_results": "Ergebnis anzeigen",
        "well_done": "Gut gemacht!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Ihre Antwort"
      },
      "video": {
        "text": "Lerne die wichtigsten Konzepte, indem du dir dieses Video ansiehst"
      }
    },
    "continue": "Weiter",
    "featured": "Ausgewählte Kurse",
    "lessons": "{count} Stunden",
    "progress": {
      "button": "Weiter",
      "text": "Sie haben {pct}% des Kurses abgeschlossen"
    },
    "skip_video": {
      "button": "Überspringen",
      "text": "Du hast dieses Video schon gesehen. Überspringen?"
    },
    "start_over": "Von vorne beginnen",
    "title": "Kurse"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "Die Frage ist abgelaufen",
        "network": "Es ist ein Fehler aufgetreten",
        "noResponse": "Es wurde keine Antwort vom Server empfangen",
        "streaming": {
          "manifest": "Beim Abspielen des Videos ist ein Fehler aufgetreten",
          "platform": "Ihr Gerät unterstützt das Abspielen dieses Videos nicht",
          "unavailable": "Dieses Video ist nicht verfügbar"
        },
        "unknown": "Ein unbekannter Fehler ist aufgetreten"
      },
      "messages": {
        "auth_failed": "Ungültige E-Mail",
        "csrf": "Aktualisieren Sie die Seite und versuchen Sie es erneut",
        "email_missing": "Keine mit dem Konto verknüpfte E-Mail-Adresse",
        "file_not_found": "Datei nicht gefunden",
        "general_exception": "Es ist ein Fehler aufgetreten",
        "invalid_answer": "Ungültige Antwort",
        "invalid_course": "Ungültiger Kurs",
        "invalid_domain": "Ungültige Domain",
        "invalid_email": "Ungültige E-Mail",
        "invalid_grant": "Konnte den Anbieter nicht kontaktieren",
        "invalid_locale": "Übersetzung nicht gefunden",
        "invalid_option": "Ungültige Option",
        "invalid_permissions": "Sie sind nicht berechtigt, diese Funktion zu nutzen",
        "invalid_point": "Ungültiger Punkt",
        "invalid_provider": "Ungültiger Anbieter",
        "invalid_quiz": "Ungültiges Quiz",
        "invalid_token": "Ihre Sitzung ist abgelaufen",
        "invalid_video": "Ungültiges Video",
        "missing_code": "Bitte versuchen Sie es erneut",
        "two_factor_code_expired": "Zwei-Faktor-Code abgelaufen",
        "two_factor_code_invalid": "Zwei-Faktor-Code ungültig",
        "unauthorized": "Sie sind nicht berechtigt, diese Funktion zu nutzen",
        "user_not_found": "Der Benutzer existiert nicht"
      },
      "validations": {
        "messages": {
          "throttle": "Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Kontostände",
        "address_book_contacts": "Kontakte im Adressbuch",
        "age_groups": "Altersgruppen",
        "ages": "Alter",
        "appointments": "Termine",
        "apps_installed_on_devices": "Auf Geräten installierte Apps",
        "astrological_signs": "Astrologische Zeichen",
        "audio_recordings": "Audioaufnahmen",
        "auth_tokens": "Authentifizierungs-Tokens",
        "avatars": "Avatare",
        "bank_account_numbers": "Bankkontonummern",
        "beauty_ratings": "Schönheitsbewertungen",
        "biometric_data": "Biometrische Daten",
        "bios": "Bios",
        "browser_user_agent_details": "Angaben zum Browser-Benutzeragenten",
        "browsing_histories": "Browserverläufe",
        "buying_preferences": "Präferenzen beim Kauf",
        "car_ownership_statuses": "Status des Autobesitzes",
        "career_levels": "Karrierestufen",
        "cellular_network_names": "Namen von Mobilfunknetzen",
        "charitable_donations": "Spenden für wohltätige Zwecke",
        "chat_logs": "Chat-Protokolle",
        "credit_card_cvv": "Kreditkarte CVV",
        "credit_cards": "Kreditkarten",
        "credit_status_information": "Informationen zum Kreditstatus",
        "customer_feedback": "Kunden-Feedback",
        "customer_interactions": "Interaktionen mit Kunden",
        "dates_of_birth": "Geburtsdaten",
        "deceased_date": "Sterbedatum",
        "deceased_statuses": "Status des Verstorbenen",
        "device_information": "Informationen zum Gerät",
        "device_serial_numbers": "Seriennummern der Geräte",
        "device_usage_tracking_data": "Daten zur Verfolgung der Gerätenutzung",
        "drinking_habits": "Trinkgewohnheiten",
        "driver_s_licenses": "Führerscheine",
        "drug_habits": "Drogenkonsum",
        "eating_habits": "Essgewohnheiten",
        "education_levels": "Bildungsgrad",
        "email_addresses": "E-Mail-Adressen",
        "email_messages": "E-Mail-Nachrichten",
        "employers": "Arbeitgeber",
        "employment_statuses": "Status der Beschäftigung",
        "encrypted_keys": "Verschlüsselte Schlüssel",
        "ethnicities": "Ethnien",
        "family_members_names": "Namen der Familienmitglieder",
        "family_plans": "Familienpläne",
        "family_structure": "Familienstruktur",
        "financial_investments": "Finanzielle Investitionen",
        "financial_transactions": "Finanzielle Transaktionen",
        "fitness_levels": "Fitness-Levels",
        "genders": "Geschlechter",
        "geographic_locations": "Geografische Standorte",
        "government_issued_i_ds": "Von der Regierung ausgestellte Personalausweise",
        "health_insurance_information": "Informationen zur Krankenversicherung",
        "historical_passwords": "Historische Passwörter",
        "hiv_statuses": "HIV-Status",
        "home_loan_information": "Informationen zu Wohnungsbaudarlehen",
        "home_ownership_statuses": "Status des Wohneigentums",
        "homepage_ur_ls": "Homepage-URLs",
        "imei_numbers": "IMEI-Nummern",
        "imsi_numbers": "IMSI-Nummern",
        "income_levels": "Einkommensniveau",
        "instant_messenger_identities": "Instant-Messenger-Identitäten",
        "ip_addresses": "IP-Adressen",
        "job_applications": "Bewerbungen",
        "job_titles": "Berufsbezeichnungen",
        "licence_plates": "Kfz-Kennzeichen",
        "living_costs": "Lebenshaltungskosten",
        "login_histories": "Login-Historien",
        "mac_addresses": "MAC-Adressen",
        "marital_statuses": "Familienstand",
        "mnemonic_phrases": "Mnemonische Phrasen",
        "mothers_maiden_names": "Mädchenname der Mutter",
        "names": "Namen",
        "nationalities": "Nationalitäten",
        "net_worths": "Nettovermögen",
        "nicknames": "Spitznamen",
        "occupations": "Berufe",
        "parenting_plans": "Kinderbetreuungspläne",
        "partial_credit_card_data": "Teilweise Kreditkartendaten",
        "partial_dates_of_birth": "Teilweise Geburtsdaten",
        "passport_numbers": "Reisepassnummern",
        "password_hints": "Passwort-Hinweise",
        "password_strengths": "Passwort-Stärken",
        "passwords": "Passwörter",
        "payment_histories": "Zahlungshistorien",
        "payment_methods": "Zahlungsmethoden",
        "personal_descriptions": "Persönliche Beschreibungen",
        "personal_health_data": "Persönliche Gesundheitsdaten",
        "personal_interests": "Persönliche Interessen",
        "phone_numbers": "Telefonnummern",
        "photos": "Fotos",
        "physical_addresses": "Physikalische Adressen",
        "physical_attributes": "Physikalische Eigenschaften",
        "pi_ns": "PINs",
        "places_of_birth": "Geburtsort",
        "political_donations": "Politische Spenden",
        "political_views": "Politische Ansichten",
        "private_messages": "Private Nachrichten",
        "professional_skills": "Berufliche Fähigkeiten",
        "profile_photos": "Profilbilder",
        "purchases": "Käufe",
        "purchasing_habits": "Kaufgewohnheiten",
        "races": "Rennen",
        "recovery_email_addresses": "E-Mail-Adressen zur Wiederherstellung",
        "relationship_statuses": "Beziehungsstatus",
        "religions": "Religionen",
        "reward_program_balances": "Belohnungsprogramm-Salden",
        "salutations": "Begrüßung",
        "school_grades_class_levels": "Schulnoten (Klassenstufen)",
        "security_questions_and_answers": "Fragen und Antworten zur Sicherheit",
        "sexual_fetishes": "Sexuelle Fetische",
        "sexual_orientations": "Sexuelle Orientierungen",
        "smoking_habits": "Rauchgewohnheiten",
        "sms_messages": "SMS-Nachrichten",
        "social_connections": "Soziale Bindungen",
        "social_media_profiles": "Profile in sozialen Medien",
        "social_security_numbers": "Sozialversicherungsnummern",
        "spoken_languages": "Gesprochene Sprachen",
        "spouses_names": "Name des Ehepartners",
        "support_tickets": "Anfragen zur Unterstützung",
        "survey_results": "Ergebnisse der Umfrage",
        "taxation_records": "Steuerunterlagen",
        "time_zones": "Zeitzonen",
        "travel_habits": "Reisegewohnheiten",
        "user_statuses": "Status der Benutzer",
        "user_website_ur_ls": "URLs von Benutzer-Websites",
        "usernames": "Benutzernamen",
        "utility_bills": "Rechnungen für Versorgungsleistungen",
        "vehicle_details": "Details zum Fahrzeug",
        "website_activity": "Website-Aktivität",
        "work_habits": "Arbeitsgewohnheiten",
        "years_of_professional_experience": "Jahre der Berufserfahrung"
      }
    },
    "certificates": {
      "compliance": "Cybersicherheitsschulung"
    },
    "courses": {
      "toc": {
        "breach-content": "Datenpanne",
        "file-content": "Download",
        "intro-content": "Einführung",
        "quiz-content": "Quiz",
        "text-content": "Fall",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "Deutsch",
      "da_DK": "Dänisch",
      "de_DE": "Deutsch",
      "en_US": "Englisch",
      "es_ES": "Spanisch",
      "fi_FI": "Finnisch",
      "fr_FR": "Französisch",
      "nb_NO": "Norwegisch",
      "nl_NL": "Niederländisch",
      "pl_PL": "Polnisch",
      "pt_PT": "Portugiesisch",
      "sv_SE": "Schwedisch"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Grüße und willkommen auf Ihrer personalisierten Lernplattform! Wir freuen uns, Sie bei uns begrüßen zu dürfen und sind bestrebt, Sie beim Erreichen Ihrer Lernziele zu unterstützen.",
              "title": "Willkommen"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Überblick über die Moxso-Plattform",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Los geht's 🙌\n",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Datenschutzbewusstsein",
          "options": {
            "high": "Vertraut",
            "low": "Unvertraut",
            "medium": "Einigermaßen vertraut"
          },
          "question": "Wie vertraut sind Sie mit den grundlegenden Prinzipien des Datenschutzes (z.B. DSGVO)?"
        },
        "device_security": {
          "category": "Gerätesicherheitspraktiken",
          "options": {
            "high": "Ja, immer",
            "low": "Nein, nie",
            "medium": "Manchmal"
          },
          "question": "Aktualisieren Sie regelmäßig Ihre Geräte und verwenden Sie Sicherheitswerkzeuge wie ein VPN?"
        },
        "digital_threats": {
          "category": "Bewusstsein für digitale Bedrohungen",
          "options": {
            "high": "Vertraut",
            "low": "Unvertraut",
            "medium": "Einigermaßen vertraut"
          },
          "question": "Wie vertraut sind Sie mit digitalen Bedrohungen wie Malware, Phishing und Ransomware?"
        },
        "hybrid_work": {
          "category": "Sicherheit beim Remote-Arbeiten",
          "options": {
            "high": "Sehr zuversichtlich",
            "low": "Nicht zuversichtlich",
            "medium": "Einigermaßen zuversichtlich"
          },
          "question": "Wie zuversichtlich sind Sie, die Sicherheit beim Arbeiten aus der Ferne (z.B. über öffentliches WLAN) aufrechtzuerhalten?"
        },
        "incidents_breaches": {
          "category": "Vorfallmeldung",
          "options": {
            "high": "Ja",
            "low": "Nein",
            "medium": "Ich habe eine allgemeine Vorstellung"
          },
          "question": "Kennen Sie das korrekte Verfahren zur Meldung eines Sicherheitsvorfalls oder Verstoßes?"
        },
        "passwords_accounts": {
          "category": "Passwortverwaltung",
          "options": {
            "high": "Ich benutze einen Passwort-Manager",
            "low": "Ich verwende Passwörter wieder",
            "medium": "Ich erstelle einzigartige, starke Passwörter"
          },
          "question": "Wie verwalten Sie Passwörter für Ihre arbeitsbezogenen Konten?"
        },
        "phishing": {
          "category": "Phishing-Erkennung",
          "options": {
            "high": "Sehr zuversichtlich",
            "low": "Nicht zuversichtlich",
            "medium": "Einigermaßen zuversichtlich"
          },
          "question": "Wie zuversichtlich sind Sie, Phishing-Versuche in E-Mails oder Nachrichten zu erkennen?"
        },
        "physical_security": {
          "category": "Physische Sicherheitspraktiken",
          "options": {
            "high": "Immer",
            "low": "Selten",
            "medium": "Manchmal"
          },
          "question": "Wie oft sichern Sie Ihren Arbeitsplatz (z.B. durch das Abschließen Ihres Computers, das Aufbewahren sensibler Dokumente)?"
        },
        "secure_browsing": {
          "category": "Sichere Surfgewohnheiten",
          "options": {
            "high": "Ja, immer",
            "low": "Nein, nie",
            "medium": "Manchmal"
          },
          "question": "Vermeiden Sie es, öffentliches WLAN zu nutzen oder auf verdächtige Links zu klicken, wenn Sie surfen?"
        }
      },
      "steps": {
        "finished": "Fertig",
        "introduction": "Einführung",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Ungültige Prüfsumme",
        "option": "Antwort nicht erkannt"
      },
      "intro": {
        "button": "Quiz starten",
        "text": "Wir werden 5 E-Mails in Ihrem Moxso-Posteingang durchgehen. Einige der E-Mails könnten von Betrügern stammen, die versuchen, Zugang zu sensiblen Daten zu erhalten - Sie müssen entscheiden, ob die E-Mail ein Phishing ist oder nicht. Sind Sie bereit?",
        "title": "Bereit zur Meldung?"
      },
      "multiple-choice": {
        "heading": "Finden Sie den Fehler in dieser E-Mail",
        "text": "Multiple-Choice-Hilfetext"
      },
      "options": {
        "email": "Die E-Mail",
        "false": "Dies ist KEIN Phishing",
        "help": {
          "email": "Der Absender ist NICHT vertrauenswürdig",
          "false": "E-Mail sollte NICHT gemeldet werden",
          "link": "Der Link führt NICHT zu einem zuverlässigen Ziel",
          "not-phishing": "Dies ist KEIN Phishing",
          "true": "E-Mail sollte gemeldet werden"
        },
        "link": "Der Link",
        "not-phishing": "Dies ist KEIN Phishing",
        "true": "Dies IST Phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Ist dies eine Phishing-E-Mail?",
        "text": "Feststellen, ob es sich um eine Phishing-E-Mail handelt oder nicht"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Dieser Kurs kann nicht aufgerufen werden. Optionale Kurse sind gesperrt, aber verpflichtende Schulungen sind weiterhin verfügbar.",
          "title": "Dieser Kurs ist gesperrt"
        },
        "quiz": {
          "description": "Sie haben Ihr Trainingslimit erreicht. Optionale Quizze sind vorerst gesperrt.",
          "title": "Quizlimit erreicht"
        },
        "video": {
          "description": "Sie haben Ihr Trainingslimit erreicht. Optionale Videos sind gesperrt, aber verpflichtende Schulungen sind weiterhin verfügbar.",
          "title": "Videolimit erreicht"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Dieser Kurs kann nicht aufgerufen werden. Optionale Kurse sind gesperrt, aber verpflichtende Schulungen sind weiterhin verfügbar.",
        "title": "Dieser Kurs ist gesperrt"
      },
      "quiz": {
        "description": "Sie haben Ihr Trainingslimit erreicht. Optionale Quizze sind vorerst gesperrt.",
        "title": "Quizlimit erreicht"
      },
      "reset": "Wird am Montag zurückgesetzt",
      "video": {
        "description": "Sie haben Ihr Trainingslimit erreicht. Optionale Videos sind gesperrt, aber verpflichtende Schulungen sind weiterhin verfügbar.",
        "limit_reached": "Limit erreicht",
        "title": "Videolimit erreicht"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Fortgeschrittene ist eine Serie für diejenigen, die sich besonders für Cybersicherheit interessieren und verstehen wollen, wie die zugrundeliegenden Mechanismen von Hacking und Cybersicherheit funktionieren. Wenn Sie nur ein grundlegendes Verständnis von Cybersicherheit erlangen wollen, dann ist es nicht notwendig, dass Sie sich die Videos in dieser Serie ansehen. Wenn Sie mehr über Hackerangriffe und Cyberattacken erfahren möchten und wissen wollen, wie Sie Ihre Cybersicherheit am besten verbessern können, sind Sie hier genau richtig.",
          "title": "Fortgeschrittene",
          "tooltip": "In kürzester Zeit zum Hacking-Experten werden"
        },
        "ai": {
          "text": "Die KI-Serie befasst sich mit der komplexen Rolle, die künstliche Intelligenz in der Cybersicherheit spielt. KI erfüllt einen doppelten Zweck: Sie ist ein wichtiges Werkzeug für IT-Sicherheitsexperten, um Bedrohungen zu erkennen und zu bewältigen, und gleichzeitig eine effektive Waffe für Hacker. Diese Videoserie soll Sie für KI-generierte Phishing-Angriffe sensibilisieren und Ihnen zeigen, wie Sie KI sicher einsetzen können, um Fehler zu minimieren und das Risiko von Hackerangriffen zu verringern. Denn auch wenn KI ein wichtiges Werkzeug sowohl für die Cyberabwehr als auch für Angriffe ist, ist Ihr Verhalten immer noch der entscheidende Faktor für Ihre Sicherheit.",
          "title": "KI und Cybersicherheit",
          "tooltip": "Erforschung der komplexen Rolle der KI in der Cybersicherheit"
        },
        "compliance": {
          "text": "Diese Kategorie enthält Videos über wichtige Rechtsvorschriften, Sicherheitsstandards und Zertifizierungen, die zum Schutz Ihres Arbeitsplatzes vor digitalen Bedrohungen beitragen können. Die Videos geben Ihnen unter anderem Einblicke in die NIS2-Richtlinie und die DORA-Verordnung, die robuste Cybersicherheitsmaßnahmen und die Einhaltung internationaler Standards gewährleisten. Die Videos geben einen Einblick in die Bedeutung der Verordnungen, in die Einhaltung der Vorschriften und in die spezifischen Anforderungen, die sie an das Sicherheits- und Risikomanagement von Unternehmen stellen. Außerdem erfahren Sie, was die Verordnungen für Sie bedeuten und warum sie Ihre Zeit wert sind.",
          "title": "Zertifizierungen und Compliance",
          "tooltip": "Verständnis für die Bedeutung von Zertifizierungen und Compliance"
        },
        "gdpr": {
          "text": "GDPR ist eine Serie, die sich mit den Regeln, Anforderungen und Grundsätzen der GDPR befasst. Die GDPR wurde 2018 eingeführt und alle Unternehmen müssen nun die GDPR einhalten, um die Integrität und den Schutz der von ihnen verarbeiteten personenbezogenen Daten zu gewährleisten. Die Reihe deckt die wichtigsten Bereiche der GDPR ab, die Sie kennen müssen, damit Sie in Ihrem Alltag personenbezogene Daten korrekt verarbeiten können. Diese Reihe umfasst Videos, die sich an alle richten, auch an Beschäftigte des privaten Sektors.",
          "title": "GDPR",
          "tooltip": "Lernen Sie die wichtigsten Anforderungen und Regeln der GDPR kennen und erfahren Sie, wie Sie diese im Alltag einhalten können."
        },
        "hacking": {
          "text": "Das Leben eines Hackers ist eine Serie, die Sie über die Menschen hinter den Cyberangriffen, die Hacker der Welt, aufklärt. Wir werfen einen genaueren Blick auf einige der Methoden, die die Hacker verwenden, um online anonym zu bleiben und wie sie ihr Geld damit verdienen. In den Videos werden außerdem die verschiedenen Arten von Hackern erklärt und warum sie so schwer zu entlarven sind.",
          "title": "Das Leben eines Hackers",
          "tooltip": "Lernen Sie die Menschen hinter den Cyberangriffen kennen, die Hacker der Welt"
        },
        "money_laundering": {
          "text": "Geldwäsche ist eine Serie, die sich mit den verschiedenen Methoden befasst, die Kriminelle zur Geldwäsche verwenden. Die Videos erklären die verschiedenen Methoden, die Kriminelle zur Geldwäsche verwenden, und wie man Geldwäsche erkennt und verhindert.",
          "title": "Geldwäsche",
          "tooltip": "Lernen Sie die verschiedenen Methoden kennen, die Kriminelle zur Geldwäsche verwenden, und wie man Geldwäsche erkennt und verhindert"
        },
        "phishing": {
          "text": "Phishing ist eine Serie, die sich mit dem weltweit am häufigsten vorkommenden Cyberangriff befasst. Phishing-Angriffe können sowohl ein eigenständiger Angriff sein als auch ein Weg, um andere, fortgeschrittenere Cyberangriffe zu starten. Phishing-Angriffe sind darüber hinaus eine Art von Cyberangriff, bei dem Sie als Mitarbeiter allein die Verantwortung dafür tragen, dass Sie nicht gehackt werden, indem Sie beispielsweise nicht auf einen Link in einer E-Mail klicken. Phishing ist ein wichtiger Schwerpunkt im Bereich der Cybersicherheit und die Videos in dieser Serie werden Ihnen ein Verständnis dafür vermitteln, wie Phishing von den Hackern durchgeführt wird und wie Sie vermeiden können, Opfer eines Phishing-Angriffs zu werden.",
          "title": "Phishing",
          "tooltip": "Entdecken Sie die Aspekte der weltweit am häufigsten vorkommenden Cyberattacke"
        },
        "physical_security": {
          "text": "Physical Security ist eine Serie, die die Bedeutung einer guten Sicherheit am Arbeitsplatz und zu Hause hervorhebt. Bei Cybersicherheit geht es um mehr als die Sicherheit Ihrer Geräte, es geht auch um die Sicherheit, die die Geräte *umgibt*. Viele Menschen kennen das mit Remote-Arbeiten und wir rüsten Sie dafür aus, dies so sicher wie möglich zu gestalten. Darüber hinaus erhalten Sie mit dieser Serie Einblicke in alles vom Besuchermanagement über Cybersicherheit auf mobilen Geräten bis hin zu den Risiken bei der Nutzung öffentlicher Netzwerke.",
          "title": "Physische Sicherheit",
          "tooltip": "Erfahren Sie, warum physische Sicherheit ein entscheidendes Element guter Cybersicherheit ist"
        },
        "tips_and_tricks": {
          "text": "Tipps und Tricks ist eine Serie, die Ihnen helfen wird, Ihre Cybersicherheit zu erhöhen. Sie erfahren, wie Sie mit wenig Aufwand Ihre persönliche Sicherheit im Internet und damit auch die Sicherheit an Ihrem Arbeitsplatz erhöhen können. In den Videos wird außerdem erklärt, warum es wichtig ist, sich an die Ratschläge zur Cybersicherheit zu erinnern, die Sie vielleicht in der Vergangenheit erhalten haben.",
          "title": "Tipps und Tricks",
          "tooltip": "Erfahren Sie, wie Sie Ihre persönliche Cybersicherheit erhöhen können"
        },
        "types_of_hacking": {
          "text": "Arten von Hacking ist eine Serie, die Ihnen einen Einblick in die verschiedenen Vorgehensweisen von Hackern gibt, wenn sie versuchen, Sie zu betrügen. Jede Folge vermittelt Ihnen ein grundlegendes Verständnis für die Merkmale einer bestimmten Hacking-Methode, was die Hacker mit dieser Methode erreichen können, welche Folgen es für Sie haben kann, wenn Sie gehackt werden, usw. Wenn Sie sich die Videos dieser Serie anschauen, sind Sie in Zukunft besser gegen Hackerangriffe gewappnet.",
          "title": "Arten von Hacking",
          "tooltip": "Einblicke in die verschiedenen Vorgehensweisen von Hackern erhalten"
        },
        "uploads": {
          "text": "Diese Kategorie enthält benutzerdefinierte Videos, die von Ihrer Organisation hochgeladen wurden.",
          "title": "Uploads",
          "tooltip": "Sehen Sie sich von Ihrer Organisation hochgeladene Videos für Ihre spezifischen Sicherheitsbedürfnisse an"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Der Fehler wurde unserem Team mit der ID: {errorId} gemeldet.\n Wenn Sie sofortige Hilfe benötigen, können Sie sich gerne an unser Support-Team unter support{'@'}moxso.com wenden.",
    "go_back": "Zurück zur Startseite",
    "text": "Es ist ein unbekannter Fehler aufgetreten, und wir konnten Ihre Anfrage nicht abschließen. Wir entschuldigen uns für die Unannehmlichkeiten. Bitte versuchen Sie es später erneut.",
    "title": "Etwas ist schief gelaufen"
  },
  "forms": {
    "fields": {
      "code": "Einmaliges Passwort",
      "email": "E-Mail"
    },
    "placeholders": {
      "email": "name{'@'}unternehmen.de"
    }
  },
  "loading": "Laden",
  "locale": {
    "current": "Deutsch",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Anmeldung",
      "next": "Nächste",
      "send_one_time_code": "Einmalcode senden",
      "try_again": "Code erneut senden"
    },
    "choose_provider": "Anbieter auswählen",
    "loading": "Laden",
    "sso": {
      "validating": "SSO wird überprüft"
    },
    "title": "Anmelden",
    "two_factor": {
      "text": "Wir haben Ihnen ein einmaliges Passwort an Ihre E-Mail geschickt.",
      "title": "Prüfen Sie Ihre E-Mail"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Sie haben die empfohlenen Inhalte fertiggestellt, die Ihr Administrator für Sie ausgewählt hat.",
      "title": "Gut gemacht!"
    },
    "deadline": "Fertigstellungstermin: {date}",
    "next_training": "Nächstes zugewiesenes Training",
    "policy_fallback_title": "Richtlinie",
    "quiz_questions": "{count} Frage | {count} Fragen",
    "retake": "Erneut zugewiesen",
    "start_quiz": "Quiz starten",
    "text": "Ihr zugewiesenes Training",
    "title": "Zugewiesenes Training",
    "view_policy": "Richtlinie anzeigen"
  },
  "navigation": {
    "breaches": "Verstöße",
    "courses": "Kurse",
    "exit": "Schließen",
    "exit_onboarding": "Einführung überspringen",
    "login": "Anmeldung",
    "logout": "Ausloggen",
    "onboarding": "Einführung",
    "onboarding_finished": "Onboarding abgeschlossen",
    "onboarding_intro": "Onboarding Einführung",
    "onboarding_quiz": "Onboarding Quiz",
    "overview": "Übersicht",
    "simulation_click": "Phishing-Simulation",
    "simulations": "Simulationen",
    "videos": "Videos"
  },
  "onboarding": {
    "finished": {
      "button": "Lernen beginnen",
      "subtitle": "Du hast dein Onboarding abgeschlossen! Gute Arbeit, du bist jetzt bereit, Moxso zu nutzen. Wir freuen uns, dich an Bord zu haben und können es kaum erwarten, dir zu helfen, deine Ziele zu erreichen!",
      "title": "Das war's!"
    },
    "intro": {
      "form": {
        "button": "Speichern und fortfahren",
        "help": "Wähle die Sprache, die du für deine Lernerfahrung verwenden möchtest.",
        "label": "Wähle deine Sprache",
        "placeholder": "Sprache wählen"
      },
      "header": {
        "description": "Willkommen auf deiner Lernplattform! Wir freuen uns, dich hier zu haben und sind bereit, dir zu helfen, deine Ziele zu erreichen. Lass uns dein Profil einrichten und dein Erlebnis anpassen.",
        "title": "Willkommen bei Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Beantworte dieses kurze Quiz, um uns zu helfen, dein aktuelles Niveau zu verstehen, damit wir das Training an deine Bedürfnisse anpassen können.",
        "title": "Wie gut kennst du dich mit Cybersicherheit aus?"
      }
    }
  },
  "overview": {
    "start_quiz": "Ein Quiz starten",
    "welcome": "Willkommen zurück"
  },
  "partner_text": "Die Moxso-Plattform wird in Zusammenarbeit mit dem {partner} vorgestellt.",
  "policies": {
    "cancel": {
      "text": "Diese Richtlinie wurde von Ihrem Administrator storniert.",
      "title": "Stornierte Richtlinie"
    },
    "continue": "Fortsetzen",
    "expired": {
      "text": "Diese Richtlinie ist abgelaufen und nicht mehr verfügbar.",
      "title": "Abgelaufene Richtlinie"
    },
    "focus": "Fokussiert",
    "history": {
      "count": "{count} unterzeichnet",
      "show_less": "Weniger anzeigen",
      "signed": "Unterzeichnet: {date}",
      "subtitle": "Prüfen Sie Richtlinien, die Sie bereits unterzeichnet haben.",
      "title": "Unterzeichnete Richtlinien",
      "view_more": "Mehr anzeigen"
    },
    "next": "Nächste",
    "overview": "Inhaltsübersicht",
    "policy": "Richtlinie",
    "quiz": {
      "confirmation_card_locked": "Sie müssen das Quiz abschließen, um fortzufahren",
      "subtitle": "Überprüfen Sie Ihr Verständnis der Richtlinie mit diesem Quiz.",
      "subtitle_completed": "Sie haben das Quiz abgeschlossen. Bestätigen Sie das Lesen der Richtlinie, um fortzufahren.",
      "title": "Quiz",
      "title_completed": "Quiz abgeschlossen"
    },
    "reader": "Lesen",
    "signature": {
      "button": "Ge nehmigen",
      "checkbox_label": "Ich habe die Richtlinie gelesen",
      "company": "Unternehmen",
      "completed": {
        "button": "Beenden",
        "policy_completed": "Richtlinie akzeptiert",
        "subtitle": "Gut gemacht! Sie haben die Richtlinie akzeptiert.",
        "title": "Richtlinie akzeptiert"
      },
      "ip_adress": "IP Adresse",
      "subtitle": "Indem du bestätigst, anerkennst du, dass du die Richtlinie gelesen und verstanden hast.",
      "title": "Bestätige das Lesen der Richtlinie",
      "user_agent": "Benutzeragent"
    },
    "this_policy_doesnt_exist_in_this_language": "Diese Richtlinie ist auf Deutsch nicht verfügbar. Zeige {locale}-Version an."
  },
  "quiz": {
    "analyze": {
      "text": "Diese E-Mail analysieren und Hilfe erhalten",
      "title": "Im Zweifel?"
    },
    "feedback": {
      "no": "Nein",
      "text": "War diese Seite hilfreich?",
      "thanks": "Vielen Dank für Ihr Feedback!",
      "yes": "Ja"
    },
    "help": {
      "button": "Nächste Frage",
      "text": "Wir haben die E-Mail analysiert und Folgendes gefunden:",
      "title": "E-Mail-Analyse"
    },
    "intro": {
      "button": "Quiz starten",
      "text": "Wir werden 5 E-Mails in Ihrem Moxso-Posteingang durchgehen. Einige der E-Mails könnten von Betrügern stammen, die versuchen, Zugang zu sensiblen Daten zu erhalten - Sie müssen entscheiden, ob die E-Mail ein Phishing ist oder nicht. Sind Sie bereit?",
      "title": "Bereit zur Meldung?"
    },
    "preview": "E-Mail-Vorschau",
    "question": "Frage {current} von {total}",
    "result": {
      "go_back": "Zu Ihrer Übersicht",
      "mails": "Erkannte Mail | Erkannte Mails",
      "points": "Gesammelte Punkte",
      "text": {
        "bad": "Leider haben Sie nur {count} E-Mails richtig kategorisiert. Aber denken Sie daran: Übung macht den Meister! | Leider haben Sie nur {count} E-Mails richtig kategorisiert. Aber denken Sie daran: Übung macht den Meister!",
        "good": "Sie haben {count} E-Mails richtig kategorisiert und das Quiz abgeschlossen. Mach weiter so!"
      },
      "title": {
        "bad": "Schade!",
        "good": "Gute Arbeit!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "Der Resilienz-Score misst Ihre Fähigkeit, Cyberangriffen zu widerstehen. Die Punktzahl wird auf der Grundlage Ihres Verhaltens in Quiz, Videos, Simulationen und Ihrer Fähigkeiten berechnet. Je höher Ihr Resilienzwert ist, desto besser sind Sie in der Lage, sich und Ihren Arbeitsplatz vor Cyberangriffen zu schützen.",
    "quizzing": {
      "text": "Verbessern Sie Ihre Leistung in Multiple-Choice-Quizzen, um Ihre Widerstandsfähigkeit zu stärken.",
      "title": "Quizzes"
    },
    "show_breakdown": "Zusammenbruch anzeigen",
    "simulations": {
      "text": "Sicheres Phishing-Verhalten verbessert Ihre Widerstandsfähigkeit. Klicken Sie nicht und denken Sie daran, es zu melden!",
      "title": "Simulationen"
    },
    "skills": {
      "text": "Deine Fähigkeiten hängen davon ab, wie du in Quizzen abschneidest. Richtige Antworten erhöhen die Widerstandsfähigkeit.",
      "title": "Fertigkeiten"
    },
    "text": "Der Resilienz-Score misst Ihre Fähigkeit, Cyberangriffen zu widerstehen.",
    "title": "Resilienz-Score",
    "videos": {
      "text": "Videos sind ein wichtiger Teil deines Trainings. Steigern Sie Ihre Widerstandsfähigkeit, indem Sie sich Videos ansehen.",
      "title": "Videos"
    }
  },
  "search": {
    "empty": "Bitte geben Sie einen Suchbegriff ein",
    "no_results": "Keine Ergebnisse gefunden",
    "placeholder": "Suche...",
    "popular": "Beliebte Suchbegriffe",
    "popular_terms": ["Ransomware", "Social Engineering"]
  },
  "simulation": {
    "alert": {
      "text": "Diese E-Mail ist Teil einer automatisierten Phishing-Übung, aber keine Sorge, es handelt sich nur um einen Test.",
      "title": "Dies ist eine Phishing-Simulation"
    },
    "baseline": {
      "text": "Wir testen derzeit Ihre Kollegen. Wir bitten Sie, diese Nachricht nicht weiterzugeben.",
      "title": "Können Sie ein Geheimnis bewahren?"
    },
    "branding": {
      "text": "Wir sind für Sie da, also zögern Sie nicht, uns zu kontaktieren.",
      "title": "Diese Übung wurde durchgeführt von Moxso"
    },
    "delivered_by": {
      "text": "Diese Übung wurde von Moxso im Auftrag von {companyName} durchgeführt. Bei Fragen können Sie sich gerne an {contactEmail} wenden.",
      "title": "Über diese Übung"
    },
    "preview": "E-Mail-Vorschau",
    "resilience_score": {
      "text": "Ihr Resilienz-Score misst Ihre Fähigkeit, Cyberangriffen zu widerstehen.",
      "title": "Ihr Resilienzwert"
    },
    "submission": {
      "text": "Du hast auf einen Link geklickt und bist auf einer gefälschten, aber überzeugenden Webseite gelandet. Bei einem echten Phishing-Angriff hätten deine Zugangsdaten gestohlen werden können. Glücklicherweise war dies nur ein Test.",
      "title": "Was ist gerade passiert?"
    },
    "training": {
      "button": "Training starten"
    }
  },
  "simulations": {
    "count": "Sie haben in den letzten 90 Tagen {count} Simulationen von Moxso erhalten.",
    "empty": {
      "text": "Sie haben in den letzten 90 Tagen keine Simulationen erhalten.",
      "title": "Keine Simulationen gefunden"
    },
    "joined": "Teilnahme am Moxso-Ausbildungsprogramm",
    "title": "Simulationen",
    "tooltip": {
      "click": "Sie haben auf den Link in dieser Simulation geklickt.",
      "report": "Sie haben diese Simulation gemeldet.",
      "submit": "Du hast dich bei dieser Simulation angemeldet."
    }
  },
  "sso": {
    "login_with": "Weiter mit {provider}",
    "or": "oder SSO verwenden",
    "redirect": "Umleitung"
  },
  "statistics": {
    "leaderboard": "Bestenliste",
    "missing_data": {
      "text": "Sie müssen Punkte sammeln, um Ihren Rang in der Rangliste zu sehen",
      "title": "Sammeln Sie Punkte, um Ihren Rang zu sehen"
    },
    "points_earned": "Erreichte {count} Punkte",
    "resilience_score": "Resilienz-Score"
  },
  "videos": {
    "error": "Fehler beim Laden des Videos",
    "latest": "Neueste Videos",
    "more": "Mehr sehen",
    "not_available_in_your_locale": "Dieses Video ist nicht auf Deutsch nicht verfügbar. Wir haben automatisch auf Englisch umgeschaltet.",
    "play": "Video abspielen",
    "quiz": {
      "resume": "Quiz fortsetzen",
      "title": "Quiz"
    },
    "related": "Verwandte Videos",
    "related_videos": "Vorgeschlagene Videos",
    "title": "Videos",
    "watch_again": "Erneut wiedergeben"
  }
}
